import { createContext, useContext, useState } from "react";
import { getAuth, setAuth, clearAuth, patchStoredAuthProfile, api } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [auth, setAuthState] = useState(getAuth());

  const login = (a, remember = true) => {
    setAuth(a, remember);
    setAuthState(a);
  };
  const logout = () => {
    clearAuth();
    setAuthState(null);
  };

  // Re-fetch current permissions so newly granted rights apply without re-login.
  const refreshMe = async () => {
    const a = getAuth();
    if (!a || a.kind !== "admin") return;
    try {
      const { data } = await api.get("/me/rights");
      const next = patchStoredAuthProfile({
        rights: data.rights,
        department: data.department,
        permission: data.permission,
        role: data.role,
      });
      if (next) setAuthState(next);
    } catch { /* ignore transient errors */ }
  };

  return (
    <AuthContext.Provider value={{ auth, login, logout, refreshMe }}>{children}</AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
